import { render, staticRenderFns } from "./file.vue?vue&type=template&id=c4f267e2&scoped=true&lang=pug"
import script from "./file.vue?vue&type=script&lang=js"
export * from "./file.vue?vue&type=script&lang=js"
import style0 from "./file.vue?vue&type=style&index=0&id=c4f267e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4f267e2",
  null
  
)

export default component.exports